module.exports = __webpack_public_path__ + "images/9f60c9d08fc8372bacc610631c95886b.png";